"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vito-d-asio": {
    "c2b90f53": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "battaias": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0cbb986": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "cedolins": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fdf1c4c0": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "fruins": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "941d061b": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "marinis": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4cc57917": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "paveon": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81c3e9d1": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "reonis": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "398a7259": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "skipSearch": false
    }],
    "selets": [{
      "hkey": "2726993c",
      "slug": "vito-d-asio",
      "name": "Vito d'Asio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8afd02e": [{
      "hkey": "61d417ce",
      "slug": "valentins",
      "name": "Valentins",
      "primary": true,
      "skipSearch": false
    }],
    "valentinis": [{
      "hkey": "61d417ce",
      "slug": "valentins",
      "name": "Valentins",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;